import { render, staticRenderFns } from "./DetailDeposit.vue?vue&type=template&id=500e274e&scoped=true"
import script from "./DetailDeposit.vue?vue&type=script&lang=ts"
export * from "./DetailDeposit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../../DATA/projects/nguonhangchina/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "500e274e",
  null
  
)

export default component.exports